import React, { useState } from 'react';
import styles from './css/index.module.css';
import { Info16Regular } from '@fluentui/react-icons';
import Slider from 'rc-slider';
import './css/rc-slider.css';
import securityInitialData, { stages } from './securityIndex.js';
import { useDispatch, useSelector } from 'react-redux';
import { GetSecurityIndexData, PatchSecurityIndexData } from '../../redux/securitySlice.js';
import { PatchProjectData } from '../../redux/projectDataSlice.js';

const MaturityIndex = () => {
    const dispatch = useDispatch();
    const [securityData, setSecurityData] = React.useState(securityInitialData);
    const { selectedProject } = useSelector(state => state.projectData);
    const { securityIndexData } = useSelector(state => state.security);
    const renderMaturityScore = () => {
        let type =
            (selectedProject?.security_index_state === 'preSeed' && 'Pre Seed') ||
            (selectedProject?.security_index_state === 'seriesA' && 'Seed / Series A+') ||
            (selectedProject?.security_index_state === 'corp' && 'Private Equity / Corporate');
        let filteredData = securityData?.filter(item => item[selectedProject?.security_index_state]);

        // Filter out N/A values (null) and calculate score only for applicable items
        let applicableData = filteredData?.filter(item => item.value !== null);
        let total = Number(applicableData?.length) * 5;
        const sumOfValues = applicableData.reduce((acc, item) => acc + item.value, 0);
        const percentage = total > 0 ? (sumOfValues / total) * 100 : 0;

        return (
            <div className={styles.maturityScoreBoard}>
                Your Security Index for a {type} Funding Round
                <div style={{ borderColor: calculateColor(parseInt(percentage)) }} className={styles.roundCirlcle}>
                    {parseInt(percentage)}
                </div>
            </div>
        );
    };
    const calculateColor = value => {
        if (value <= 15) {
            return '#B00020';
        }
        if (value >= 16 && value <= 35) {
            return '#FF4E11';
        }
        if (value >= 36 && value <= 50) {
            return '#FF8E15';
        }
        if (value >= 51 && value <= 65) {
            return '#FAB733';
        }
        if (value >= 66 && value <= 80) {
            return '#ACB334';
        }
        if (value >= 81 && value <= 100) {
            return '#69B34C';
        }
    };
    const handleSelectSelectedType = value => {
        dispatch(
            PatchProjectData({
                data: {
                    security_index_state: value,
                },
                id: selectedProject?.id,
            }),
        );
        dispatch(
            PatchSecurityIndexData({
                id: securityIndexData?.id,
                body: {
                    total_score: handleGetPercentage(securityData, value),
                },
            }),
        );
    };
    const handleGetPercentage = (data, type) => {
        let filteredData = data?.filter(item => item[type]);
        // Filter out N/A values (null) and calculate score only for applicable items
        let applicableData = filteredData?.filter(item => item.value !== null);
        let total = Number(applicableData?.length) * 5;
        const sumOfValues = applicableData.reduce((acc, item) => acc + item.value, 0);
        const percentage = total > 0 ? (sumOfValues / total) * 100 : 0;
        return parseInt(percentage);
    };

    React.useEffect(() => {
        if (securityIndexData?.id) {
            let data = securityInitialData?.map(item => {
                if (securityIndexData?.[item?.key] !== undefined && securityIndexData?.[item?.key] !== null) {
                    return {
                        ...item,
                        value: securityIndexData[item?.key],
                    };
                } else {
                    return {
                        ...item,
                        value: null, // Set to null if no value exists
                    };
                }
            });
            setSecurityData(data);
        }
    }, [securityIndexData]);
    React.useEffect(() => {
        dispatch(GetSecurityIndexData());
    }, []);
    return (
        <div className={styles.viewBody}>
            <h3 className={styles.pageHeading}>Security Index</h3>
            <p className={styles.subTitle}>Choose your funding round and review scope items' implementation status for your Security Index.</p>

            <div className="d-flex flex-wrap ">
                <button
                    onClick={() => handleSelectSelectedType('preSeed')}
                    className={styles.headerSimpleButton + ' ' + (selectedProject?.security_index_state === 'preSeed' && styles.selectedBtn)}>
                    Pre Seed
                </button>
                <button
                    onClick={() => handleSelectSelectedType('seriesA')}
                    className={styles.headerSimpleButton + ' ' + (selectedProject?.security_index_state === 'seriesA' && styles.selectedBtn)}>
                    Seed / Series A+
                </button>
                <button
                    onClick={() => handleSelectSelectedType('corp')}
                    className={styles.headerSimpleButton + ' ' + (selectedProject?.security_index_state === 'corp' && styles.selectedBtn)}>
                    Private Equity / Corporate
                </button>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-9">
                    <div className={styles.maturityIndexBody}>
                        <table className="w-100">
                            <thead>
                                <tr className={styles.tableRow}>
                                    <td className={styles.headerItem}>Scope Item</td>
                                    <td className={styles.headerItem} style={{ width: 230 }}>
                                        <div className="d-flex align-items-center position-relative">
                                            <span className={styles.statusHeading}> Select Current Status</span> &nbsp;
                                            <div className={styles.showInfoMenu}>
                                                <Info16Regular color="var(--Neutral-Gray-6)" />
                                                <div className={styles.infoMenu}>
                                                    {stages?.map(item => (
                                                        <div className={styles.infoMenuItem}>
                                                            <p> {item?.title}</p>
                                                            <span>{item?.description}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                {securityData?.map(
                                    item =>
                                        item[selectedProject?.security_index_state] && (
                                            <tr key={item?.description} className={styles.tableRow}>
                                                <td className={styles.tableItem}>
                                                    <p>{item?.label}</p>
                                                    <span>{item?.description}</span>
                                                </td>
                                                <td className="text-center ps-3 pe-5">
                                                    <TableSlider
                                                        securityData={securityData}
                                                        handleGetPercentage={handleGetPercentage}
                                                        item={item}
                                                        setSecurityData={setSecurityData}
                                                    />
                                                </td>
                                            </tr>
                                        ),
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-12 col-md-3">{renderMaturityScore()}</div>
            </div>
        </div>
    );
};

const TableSlider = ({ item, setSecurityData, securityData, handleGetPercentage }) => {
    const { securityIndexData } = useSelector(state => state.security);
    const { selectedProject } = useSelector(state => state.projectData);
    const [sliderValue, setSliderValue] = useState(item?.value);
    const [showMenu, setShowMenu] = React.useState(false);
    const dispatch = useDispatch();
    const calculateColor = value => {
        // Return grey for N/A (null) values
        if (value === null) {
            return '#6C757D'; // Grey color for N/A
        }

        const startColor = [176, 0, 32]; // #B00020
        const middleColor = [250, 183, 51]; // #FAB733
        const endColor = [105, 179, 76]; // #69B34C
        const interpolate = (start, end, percent) => {
            return start + (end - start) * percent;
        };
        if (value <= 2) {
            const red = interpolate(startColor[0], middleColor[0], value / 2);
            const green = interpolate(startColor[1], middleColor[1], value / 2);
            const blue = interpolate(startColor[2], middleColor[2], value / 2);
            return `rgb(${red}, ${green}, ${blue})`;
        } else {
            const red = interpolate(middleColor[0], endColor[0], (value - 2) / 3);
            const green = interpolate(middleColor[1], endColor[1], (value - 2) / 3);
            const blue = interpolate(middleColor[2], endColor[2], (value - 2) / 3);
            return `rgb(${red}, ${green}, ${blue})`;
        }
    };
    const getStageContent = value => {
        const stage = stages[value === null ? 0 : value + 1]; // Adjust index for N/A option
        return stage ? (
            <div className={styles.sliderMenu}>
                <h6>{stage.title}</h6>
                <p>{stage.description}</p>
            </div>
        ) : null;
    };
    const handleSliderChange = value => {
        // Convert -1 to null for N/A
        const actualValue = value === -1 ? null : value;

        let updatedData = securityData?.map(data => {
            if (data?.key === item?.key) {
                return {
                    ...data,
                    value: actualValue,
                };
            } else return data;
        });
        dispatch(
            PatchSecurityIndexData({
                id: securityIndexData?.id,
                body: {
                    [item?.key]: actualValue,
                    total_score: handleGetPercentage(updatedData, selectedProject?.security_index_state),
                },
            }),
        );
        setSecurityData(updatedData);
        setSliderValue(actualValue);
    };
    React.useEffect(() => {
        if (item) {
            setSliderValue(item?.value);
        }
    }, [item]);
    return (
        <div className="position-relative" style={{ width: 230 }}>
            <Slider
                value={sliderValue === null ? -1 : sliderValue}
                onChange={handleSliderChange}
                step={null}
                max={5}
                min={-1}
                onFocus={() => setShowMenu(true)}
                onBlur={() => setShowMenu(false)}
                marks={{
                    '-1': <span />,
                    0: <span />,
                    1: <span />,
                    2: <span />,
                    3: <span />,
                    4: <span />,
                    5: <span />,
                }}
                railStyle={{
                    background: 'var(--Neutral-Gray-5)',
                    borderRadius: 0,
                }}
                trackStyle={{
                    background: calculateColor(sliderValue),
                }}
                handleStyle={{
                    border: `1px solid ${calculateColor(sliderValue)}`,
                    background: calculateColor(sliderValue),
                    boxShadow: 'none',
                    opacity: 1,
                }}
                dotStyle={{
                    background: `var(--Neutral-Gray-5)`,
                    border: 'none',
                    borderRadius: 4,
                    width: 2,
                }}
                activeDotStyle={{
                    border: `1px solid ${calculateColor(sliderValue)}`,
                    background: calculateColor(sliderValue),
                }}
            />
            {showMenu && getStageContent(sliderValue)}
        </div>
    );
};

export default MaturityIndex;
